/**
 * True when billable active users have reached purchased seats and the UI should block
 * actions that would activate or add another billable user (Admin, table, bulk, webapp).
 *
 * @param {Object} params
 * @param {number} [params.totalBillableUsers] — current billable user count (Admin summary / table)
 * @param {number} [params.totalUsersPurchased] — purchased seat count from implementation
 * @param {boolean} [params.isFreeImpl] — free subscription: no purchased-seat enforcement in UI
 */
export function isAtSeatLimit({ totalBillableUsers, totalUsersPurchased, isFreeImpl }) {
    if (isFreeImpl) return false;
    const purchased = Number(totalUsersPurchased);
    if (!Number.isFinite(purchased) || purchased <= 0) return false;
    const billable = Number(totalBillableUsers);
    if (!Number.isFinite(billable)) return false;
    return billable >= purchased;
}
